// src/hooks/useUpdateClienteIntermedioWithUsuario.ts
import type { UpdateAprendizPayload } from "@/interfaces/user.interface";
import { axiosInstance } from "@retro-ia/shared/axios";
import {
  useMutation,
  useQueryClient,
  type QueryKey,
} from "@tanstack/react-query";
import { toast } from "sonner";

export const useUpdateAprendizWithUsuario = (queryKey?: QueryKey) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, data }: UpdateAprendizPayload) => {
      const res = await axiosInstance.patch(`/aprendices/${id}`, data, {
        withCredentials: true,
      });
      return res.data;
    },
    onSuccess: (_data, variables) => {
      if (queryKey && queryKey.length > 0) {
        queryClient.invalidateQueries({ queryKey });
      } else {
        queryClient.invalidateQueries({ queryKey: ["aprendices"] });
      }
      queryClient.invalidateQueries({ queryKey: ["aprendiz", variables.id] });
      toast.success("Aprendiz actualizado correctamente.");
    },
    onError: () => {
      toast.error("Error al actualizar");
    },
  });
};
